module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_3_02-5f6f072ed0a257361307b81b3bd586de.jpg";